const userInitialState = {
    data: null
};

export default function userReducer(state = userInitialState, action) {
    return state;
}